import base_store from './base'
import user from './user'
import auth from './auth'
import maarima from './maarima'
import router from './router'
import bugs from './bugs'
import connection from './connection'

const modules = [router, user, maarima, bugs, connection]

const initialize = async () => {
    base_store.dispatch('initialize')
    await base_store.register(auth)
    for (var module of modules) {
        await base_store.register(module)
    }
    return base_store
}

export const initializer = initialize
export const store = base_store
export default store

// var example = {
//     name: 'user',
//     // function returning a pre-built state object or
//     // the state object itself which will be duplicated
//     // to reproduce the 'empty' state
//     state,
//     // standard mutations object as per vuex docs
//     mutations,
//     // standard actions object as per vuex docs
//     actions,
//     // standard getters object as per vuex docs
//     getters,
//     // persistence object contains all persistence related settings
//     persistence: {
//         // if a type is selected, load and save functions will be set
//         // to use that type, any provided load/save function (below) will
//         // override these default functions.
//         // Options are: ['localStorage', 'sessionStorage', 'cookie', 'zutak']
//         type: 'localStorage',
//         load: () => {
//             return {
//                 token: localStorage.setItem('token', state.token),
//                 expiry: localStorage.setItem('expiry', state.expiry)
//             }
//         },
//         save: (mutation, state) => {
//             localStorage.setItem('token', state.token)
//             localStorage.setItem('expiry', state.expiry)
//             api.sendToServer(state)
//         },
//         // names of actions to ignore state persistence for
//         // any actions listed here will not trigger a persistence event
//         // for the state of the module
//         ignored_mutations: ['MUTATIONS_TO', 'IGNORE_PERSISTENCE', '_FOR'],
//         // function which will receive the mutation triggering the
//         // persistence event and has the chance to add, remove or otherwise
//         // manipulate the state prior to persistence
//         reducer: (mutation, state) => {
//             if (mutation == 'SET_COLLAPSED') {
//                 return {}
//             }
//             return {
//                 id: state.id,
//                 name: state.name
//             }
//         }
//     },
//     auth: {
//         // if true, clear the state on logout
//         require: false,
//         // Strings (representing action name) or Functions
//         hooks: {
//             login: '',
//             logout: '',
//             refresh: ''
//         }
//     }
// }
